import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { EmailNotificationService } from 'src/app/services/settings-services/email-notification.service';
import { TwitterService } from 'src/app/services/social/twitter.service';

@Component({
  selector: 'app-twitter-reply',
  templateUrl: './twitter-reply.component.html',
  styleUrls: ['./twitter-reply.component.css']
})
export class TwitterReplyComponent implements OnInit {

  loading: boolean = false;
  socket: any;
  twitter_account: any = {};

  tweet: any = {};
  reply_body: string = '';
  character_count: number = 0;
  limit_exceeded: boolean = false;

  selected_template: any;

  constructor(
    private commsNotification: EmailNotificationService,
    private twitterService: TwitterService,
    private toaster: ToastrService,
  ) {
    this.socket = this.commsNotification.get_socket();
  }

  ngOnInit() {
    this.twitterService.tweet_to_reply.subscribe(tweet => {
      if (!Object.keys(tweet).length) return;

      this.tweet = tweet;
      this.openModal();
    });

    this.twitterService.fetch_user_data().subscribe((response: any) => {
      const { payload, success } = response;
      if (success) {
        this.twitter_account = payload;
      } else {
        this.toaster.error(`Could not fetch Twitter data`);
      }
    }, e => {
      this.toaster.error(`Could not fetch Twitter data`);
    });
  }

  countCharacters() {
    this.character_count = this.reply_body.length;
    this.limit_exceeded = this.character_count >= 140;
  }

  openModal() {
    document.getElementById('tweetReplyModalBtn').click();
  }

  reply() {
    const status = this.reply_body.trim();
    if (!status) {
      this.toaster.error('Enter a valid text');
      return;
    }

    if (status.length > 140) {
      this.toaster.error('Text too long.');
      return;
    }

    if (!this.twitter_account._id) {
      this.toaster.error('No Account connected');
      return;
    }

    const data_to_send = {
      status,
      user_id: this.twitter_account.tweep_id,
      org_id: this.tweet.orgId,
      in_reply_to: this.tweet.tweet_id,
      author: this.tweet.author_id
    }

    this.loading = true;
    this.twitterService.send_reply(data_to_send).subscribe((response: any) => {
      this.loading = false
      if (response.success) {
        this.toaster.success(`Reply sent.`);
        const { orgId, tweet_id } = this.tweet;
        this.socket.emit('tweet:handled', { orgId, tweet_id });
        this.tweet.is_handled = true;
        this.reply_body = '';
        return;
      }

      this.toaster.error('Reply failed.');
    }, (error: any) => {
      this.loading = false;
      this.toaster.error('Reply failed.');
    });
  }

  selectTemplate(template) {

  }

}
